import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
const TOTAL = 17 * 60 + 34;
export function Countdown() {
  const {
    h,
    m,
    s
  } = useCountdown(TOTAL);
  const units = [{
    v: h,
    l: 'Hours'
  }, {
    v: m,
    l: 'Minutes'
  }, {
    v: s,
    l: 'Seconds'
  }];
  return <div className="w-full max-w-xl text-center" data-id="element-20" data-mp="3q1nj9y823tdn">
      <p className="font-display text-lg font-bold uppercase tracking-wide text-alert" data-id="element-21" data-mp="3q0cf3xap8jm0">The $27 promotional price ends in:</p>
      <div className="mt-2 flex items-start justify-center gap-2" role="timer" aria-live="off" data-id="element-22" data-mp="3c3yysrhwio94">
        {units.map((u, i) => <React.Fragment key={u.l} data-id="element-23" data-mp="323yb6td01lz4" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-24" data-mp="324zzw0mxu6zb">
              <span className="w-[78px] rounded-xl bg-alert py-2 font-display text-5xl font-black tabular-nums text-white sm:w-24 sm:text-6xl" data-id="element-25" data-mp="372je50jmyjr9">
                {u.v}
              </span>
              <span className="mt-1 text-xs font-semibold uppercase tracking-wide text-muted" data-id="element-26" data-mp="10aihtopj1t0g">{u.l}</span>
            </div>
            {i < units.length - 1 && <span className="pt-2 font-display text-5xl font-black text-alert" data-id="element-27" data-mp="y050iez5y6wb">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}